// App
import { Analytics } from "@js/analytics";
import { App } from "@js/app";
import { Router } from "@js/router";
import { init } from "scroll-magic-lite";

// Styles
import "@styles/style.scss";

const router = new Router();
router.init();

if (router.isLandingRoute()) {
  init();

  const app = new App();
  app.init();
}

Analytics.init();
